/* TATIMI / Ritual Phoenix Star animation controller */
(function(){
  'use strict';
  if(window.__tatimiRitualLogoSpinV2)return;
  window.__tatimiRitualLogoSpinV2=true;
  var selector='.header-logo .tatimi-phoenix-spin-logo';
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  var initialized=false;
  function allowed(){return !reduced.matches;}
  function linkFor(node){return node && node.closest?node.closest('.header-logo'):null;}
  function setMode(image,mode){
    if(!image||!allowed())return;
    if(image.getAttribute('data-tatimi-spin')===mode)return;
    image.removeAttribute('data-tatimi-spin');
    void image.offsetWidth;
    if(mode)image.setAttribute('data-tatimi-spin',mode);
  }
  function onLink(link,mode){
    if(!link)return;
    link.querySelectorAll('.tatimi-phoenix-spin-logo').forEach(function(image){setMode(image,mode);});
  }
  function spinOnce(){
    if(!allowed()||document.visibilityState==='hidden')return;
    document.querySelectorAll(selector).forEach(function(image){
      var link=linkFor(image);
      if(link&&(link.matches(':hover')||link.contains(document.activeElement))){
        setMode(image,'hover');
      }else{
        image.removeAttribute('data-tatimi-spin');
        void image.offsetWidth;
        image.setAttribute('data-tatimi-spin','once');
      }
    });
  }
  document.addEventListener('pointerover',function(event){
    var link=linkFor(event.target);
    if(link&&!link.contains(event.relatedTarget))onLink(link,'hover');
  });
  document.addEventListener('pointerout',function(event){
    var link=linkFor(event.target);
    if(link&&!link.contains(event.relatedTarget)&&!link.contains(document.activeElement))onLink(link,null);
  });
  document.addEventListener('focusin',function(event){onLink(linkFor(event.target),'hover');});
  document.addEventListener('focusout',function(event){
    var link=linkFor(event.target);
    if(link&&!link.contains(event.relatedTarget)&&!link.matches(':hover'))onLink(link,null);
  });
  document.addEventListener('pointerdown',function(event){
    if(event.pointerType==='mouse')return;
    var link=linkFor(event.target);
    if(link)onLink(link,'once');
  });
  document.addEventListener('animationend',function(event){
    if(event.animationName!=='tatimi-ritual-logo-once'||!event.target.matches(selector))return;
    var link=linkFor(event.target);
    if(link&&(link.matches(':hover')||link.contains(document.activeElement)))setMode(event.target,'hover');
    else event.target.removeAttribute('data-tatimi-spin');
  });
  document.addEventListener('shopify:section:load',function(){requestAnimationFrame(spinOnce);});
  document.addEventListener('shopify:section:select',function(){requestAnimationFrame(spinOnce);});
  document.addEventListener('shopify:block:select',function(){requestAnimationFrame(spinOnce);});
  window.addEventListener('pageshow',function(event){if(event.persisted)requestAnimationFrame(spinOnce);});
  function start(){
    if(initialized)return;
    initialized=true;
    requestAnimationFrame(function(){requestAnimationFrame(spinOnce);});
    window.setInterval(spinOnce,60000);
  }
  if(document.readyState==='complete')start();
  else window.addEventListener('load',start,{once:true});
})();
